import { sessionStorage } from '@rover/utilities/storage';

export const getItem = (key: string): string | null => sessionStorage.getItem(key);

export const setItem = (key: string, value: string): void => sessionStorage.setItem(key, value);

export const removeItem = (key: string): void => sessionStorage.removeItem(key);

export const clear = (): void => sessionStorage.clear();
